import { Effect, Function, RequestResolver } from 'effect';
import * as Url from '../../../url';
import { ServerError } from '../errors';
import { Schema } from '@effect/schema';
import { Templates } from '../template';
export const makeGetForSpaceResolver = (http) => RequestResolver.fromEffect((request) => {
    const url = Url.join(request.baseUrl, `/api/v1/${request.tenant}/templates`, {
        space: request.space,
    });
    return http.get(url).pipe(Effect.flatMap(Function.flow(res => res.body, Schema.decodeUnknown(Templates))), Effect.mapError(originalError => new ServerError({ originalError, url })));
});
export const makeGetByIdResolver = (http) => RequestResolver.fromEffect((request) => {
    const url = Url.join(request.baseUrl, `/api/v1/${request.tenant}/templates/${request.templateId}`);
    return http.get(url).pipe(Effect.flatMap(Function.flow(res => res.body, Schema.decodeUnknown(Schema.Struct({ templates: Templates })))), Effect.map(body => body.templates[0]), Effect.mapError(originalError => new ServerError({ originalError, url })));
});
